import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Button } from 'antd';
import './Buttons.css';

const stateEnum = Object.freeze({
  NORMAL: 0,
  WAITING: 1,
});


/**
 * Button that requires a confirmation click within a certain amount of seconds to execute.
 */
export default function ConfirmButton({
  confirmSeconds, onClick, loading, className, children, ...rest
}) {
  const intl = useIntl();
  const [buttonState, setButtonState] = useState(stateEnum.NORMAL);
  const [loadingHere, setLoadingHere] = useState(false);
  const [text, setText] = useState(children);

  const changeConfirm = () => {
    setButtonState(stateEnum.WAITING);
    setText(intl.formatMessage({ id: 'confirm' }));
  };

  const changeNormal = () => {
    setButtonState(stateEnum.NORMAL);
    setText(text);
  };

  const delayedMethod = timeOut => new Promise((resolve) => {
    setTimeout(resolve, timeOut);
  });

  const clickButton = (e) => {
    e.preventDefault();
    if (buttonState === stateEnum.NORMAL) {
      changeConfirm();
      delayedMethod(1000 * confirmSeconds).then(changeNormal);
    } else if (buttonState === stateEnum.WAITING) {
      changeNormal();
      setLoadingHere(true);
      onClick(e);
      setLoadingHere(false);
    }
    e.target.blur();
  };

  return (
    <Button className={buttonState === stateEnum.WAITING ? 'via-confirm-button-waiting' : className} loading={loading || loadingHere} onClick={e => clickButton(e)} {...rest}>
      { text }
    </Button>
  );
}

ConfirmButton.propTypes = {
  className: PropTypes.string,
  confirmSeconds: PropTypes.number,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

ConfirmButton.defaultProps = {
  className: '',
  confirmSeconds: 3,
  loading: false,
  onClick: () => {},
  children: '',
};
